import { vendorAddressesReducer } from './vendorAddresses.reducer'
export * from './vendorAddresses.types'
export * from './vendorAddresses.actions'
export * from './vendorAddresses.thunks'

export default vendorAddressesReducer
